import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export const recordAccessApi = {
  status: (patientId, queueEntryId = '') =>
    axios.get(`${API}/api/record-access/${patientId}`, {
      params: queueEntryId ? { queue_entry_id: queueEntryId } : undefined,
      withCredentials: true,
    }).then((r) => r.data),
  limited: (patientId) =>
    axios.get(`${API}/api/record-access/${patientId}/limited`, { withCredentials: true }).then((r) => r.data),
  requestOtp: (patientId, channel) =>
    axios.post(
      `${API}/api/record-access/${patientId}/request-otp`,
      { channel },
      { withCredentials: true },
    ).then((r) => r.data),
  verifyOtp: (patientId, challengeId, otp) =>
    axios.post(
      `${API}/api/record-access/${patientId}/verify-otp`,
      { challenge_id: challengeId, otp },
      { withCredentials: true },
    ).then((r) => r.data),
};
